var IconButton    = require("app/ui/IconButton"),
    frameThrottle = require("enyo-perf/utils").frameThrottle,
    get           = require("object-path").get,
    kind          = require("enyo/kind");

require("app/theme/IconButton--header-positive.less");
require("app/theme/IconButton--header-negative.less");

module.exports = kind(/** @lends  app.AppHeader.PreviewModeButton.prototype */ {

    /**
     * @private
     */
    name: "app.AppHeader.PreviewModeButton",

    /**
     * @private
     */
    kind: IconButton,

    /**
     * @private
     */
    classes: "app-app-header-preview-mode-button",

    /**
     * The theme to use when previewMode is enabled.
     */
    theme: "header-positive",

    /**
     * @type  {string|null}
     * @public
     */
    loadingIcon: null,

    /**
     * @type  {string|null}
     * @public
     */
    previewModeOnIcon: null,

    /**
     * @type  {string|null}
     * @public
     */
    previewModeOffIcon: null,

    /**
     * Align the icon on the left or the right.
     *
     * @type  {?string}
     * @public
     */
    iconAlignment: "left",

    /**
     * @private
     */
    observers: {
        update: ["isSubmitting"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);

            // Update content
            this.observe("app.$.i18nService.translation", this.update);
            this.observe("app.$.authService.user", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var i18nService = this.app.$.i18nService,
            user        = this.app.$.authService.user;

        if (this.get("isSubmitting")) {
            this.set("icon", this.loadingIcon);
            !this.hasClass("loading") && this.addClass("loading");

            while (this.hasClass("active")) {
                this.removeClass("active");
            }
        }
        else if (get(user, "preview_mode", false)) {
            this.set("icon", this.previewModeOnIcon);

            while (this.hasClass("loading")) {
                this.removeClass("loading");
            }

            if (!this.hasClass("active")) {
                this.addClass("active");
            }
            this.set("tooltip", i18nService.getString("app.AppHeader.PreviewModeButton.Tooltip.previewModeOn"));
            this.set("caption", i18nService.getString("app.AppHeader.PreviewModeButton.Caption.previewModeOn"));
        }
        else {
            this.set("icon", this.previewModeOffIcon);

            while (this.hasClass("loading")) {
                this.removeClass("loading");
            }

            while (this.hasClass("active")) {
                this.removeClass("active");
            }
            this.set("tooltip", i18nService.getString("app.AppHeader.PreviewModeButton.Tooltip.previewModeOff"));
            this.set("caption", i18nService.getString("app.AppHeader.PreviewModeButton.Caption.previewModeOff"));
        }
    },

    /**
     * Instruct the router to navigate to the new location
     *
     * @private
     */
    tap: function() {
        var authService = this.app.$.authService,
            user        = authService.user;

        // The user state will be updated by the Service, the core App will
        // respond to changes in `preview_mode` property and refresh the page.
        this.set("isSubmitting", true);
        authService.togglePreviewMode(!get(user, "preview_mode", false))
            .then(this.bindSafely(function() {
                this.app.$.router.refresh();
            }))
            .finally(this.bindSafely(function() {
                this.set("isSubmitting", false);
            }));
    }

});
